import { effect, signal } from "@preact/signals";
import type { Message } from "./types";

function readSessionId(): string | null {
  try {
    return localStorage.getItem("iskra-chat-session");
  } catch {
    return null;
  }
}

function readCustomer(): { name: string; email: string } {
  try {
    return {
      name: localStorage.getItem("iskra-chat-name") || "",
      email: localStorage.getItem("iskra-chat-email") || "",
    };
  } catch {
    return { name: "", email: "" };
  }
}

const initialCustomer = readCustomer();

export const sessionId = signal<string | null>(readSessionId());
export const panelOpen = signal(false);
// Samtalen lagres per fane (sessionStorage): lenker til badstugutta.no åpnes
// i samme fane, og da skal samtalen fortsatt være der når kunden åpner chatten
// på neste side. Panelet åpnes IKKE av seg selv, så det ikke dekker siden.
function readMessages(): Message[] {
  try {
    const raw = sessionStorage.getItem("iskra-chat-msgs");
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
export const messages = signal<Message[]>(readMessages());
effect(() => {
  try {
    sessionStorage.setItem("iskra-chat-msgs", JSON.stringify(messages.value.slice(-40)));
  } catch {
    /* sessionStorage blokkert — samtalen lever bare i minnet */
  }
});
export const inputValue = signal("");
export const isThinking = signal(false);
export const escalationView = signal(false);
export const escalationSent = signal(false);
export const error = signal<string | null>(null);
export const customerName = signal<string>(initialCustomer.name);
export const customerEmail = signal<string>(initialCustomer.email);
export const operatorLive = signal(false);
export const operatorName = signal<string | null>(null);

// Pre-filled mail-draft for EscalationForm. Settes når kunden klikker
// "Send mail" på et Iskra-foreslått e-post-utkast. EscalationForm leser
// dette og pre-fyller meldings-feltet. Nullstilles ved submit / tilbake.
export const prefilledMail = signal<string | null>(null);

export function setSessionId(id: string) {
  sessionId.value = id;
  try {
    localStorage.setItem("iskra-chat-session", id);
  } catch {
    /* localStorage blocked — keep in-memory only */
  }
}

export function setCustomer(name: string, email: string) {
  // [TRACKING-HOOK] gate_submitted: Kunden har nå gitt navn + e-post.
  // Lavere intent enn escalation, men en tydelig "lead capture"-event.
  // Fyre GA4 "sign_up" + Meta Pixel "Lead" (lavere kvalitet) i fremtidig sesjon.
  customerName.value = name;
  customerEmail.value = email;
  try {
    localStorage.setItem("iskra-chat-name", name);
    localStorage.setItem("iskra-chat-email", email);
  } catch {
    /* localStorage blocked — keep in-memory only */
  }
}

export function addMessage(msg: Message) {
  messages.value = [...messages.value, msg];
}
